export type FormatType = "minified" | "yaml" | "toml" | "CSV" | "toon"

export const FORMAT_ORDER: FormatType[] = [
  "minified",
  "yaml",
  "toml",
  "CSV",
  "toon",
]
